// extracted by mini-css-extract-plugin
module.exports = {"logoMobile":"ThemedLogo_logoMobile__En8I7"};